import React from 'react'

import { ThirthSectionData } from '../../../services/config.json/academy/missions/ThirthSectionData'
import { Check, Dot } from 'lucide-react';

import ColorPallet from '../../../utils/ColorPallet';

function SecondSection() {
  return (
   <div className="p-8" style={{ backgroundColor: ColorPallet.primaryLightBrown }}>
      <h1 className="text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text mb-4 mt-7">PROGRAM / KURIKULUM</h1>
      <h1 className="text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text mb-8">(RAMBUT PROFESIONAL)</h1>

      <div className="grid grid-cols-3 gap-8">
        <div>
          <h2 className="text-2xl font-medium mb-2" style={{ color: ColorPallet.primaryDarkBrown }}>Pengetahuan Umum</h2>
          <ul className="text-gray-400 text-lg space-y-1">
            {ThirthSectionData.pengetahuanUmum.map((item, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700">
                <Check size={16} className="text-green-500" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-medium  mb-2" style={{ color: ColorPallet.primaryDarkBrown }}>Materi & Teori</h2>
          <ul className="text-gray-400 text-lg space-y-1">
            {ThirthSectionData.materiTeori.map((item, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700">
                <Check size={16} className="text-green-500" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-medium mb-2" style={{ color: ColorPallet.primaryDarkBrown }}>Simulasi (Manekin)</h2>
          <ul className="text-gray-400 text-lg space-y-1">
            {ThirthSectionData.simulasi.map((item, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700">
                <Check size={16} className="text-green-500" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-medium mb-2" style={{ color: ColorPallet.primaryDarkBrown }}>Praktek (Model)</h2>
          <ul className="text-gray-400 text-lg space-y-1">
            {ThirthSectionData.praktek.map((item, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700">
                <Check size={16} className="text-green-500" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-medium mb-2" style={{ color: ColorPallet.primaryDarkBrown }}>Layanan Ekstra</h2>
          <ul className="text-gray-400 text-lg space-y-1">
            {ThirthSectionData.layananEkstra.map((item, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700">
                <Check size={16} className="text-green-500" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-medium mb-2" style={{ color: ColorPallet.primaryDarkBrown }}>Soft Skill</h2>
          <ul className="text-gray-400 text-lg space-y-1">
            {ThirthSectionData.softSkill.map((item, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700">
                <Check size={16} className="text-green-500" />
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Note */}
        <div className="col-span-3 mb-7">
          <h2 className="text-lg font-medium mb-2" style={{ color: ColorPallet.primaryDarkBrown }}>*Note : </h2>
          <ul className="text-gray-400 text-lg space-y-1">
            {ThirthSectionData.note.map((item, index) => (
              <li key={index} className="flex items-center gap-2 text-gray-700 font-bold capitalize">
                <Dot size={20} className="text-green-500" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default SecondSection